const callingCodes = {
  AE: '971',
  AL: '355',
  AM: '374',
  AR: '54',
  AT: '43',
  AU: '61',
  AZ: '994',
  BA: '387',
  BB: '1',
  BE: '32',
  BG: '359',
  BH: '973',
  BR: '55',
  BW: '267',
  CA: '1',
  CH: '41',
  CL: '56',
  CR: '506',
  CY: '357',
  CZ: '420',
  DE: '49',
  DK: '45',
  DO: '1',
  EE: '372',
  EG: '20',
  ES: '34',
  FI: '358',
  FR: '33',
  GB: '44',
  GE: '995',
  GR: '30',
  HR: '385',
  HU: '36',
  ID: '62',
  IE: '353',
  IS: '354',
  IT: '39',
  JM: '1',
  JO: '962',
  JP: '81',
  LB: '961',
  LT: '370',
  LU: '352',
  LV: '371',
  MA: '212',
  ME: '382',
  MK: '389',
  MT: '356',
  MX: '52',
  MY: '60',
  NL: '31',
  NO: '47',
  NZ: '64',
  PL: '48',
  PT: '351',
  RE: '262',
  RO: '40',
  RS: '381',
  SE: '46',
  SI: '386',
  SK: '421',
  SM: '378',
  TN: '216',
  TR: '90',
  UK: '44',
  US: '1',
  VA: '39',
  ZA: '27'
}

const countriesWithSignificantLeadingZero = ['IT', 'SM', 'VA']

export const normaliseCountryCode = value => {
  if (!value) return null

  const code = String(value).trim().toUpperCase()

  return code.length ? code : null
}

export const normalisePhoneNumber = (value, countryCode) => {
  if (!value) return undefined

  const raw = String(value).trim()
  const normalisedCountryCode = normaliseCountryCode(countryCode)
  const callingCode = callingCodes[normalisedCountryCode]
  const hasInternationalPrefix = raw.startsWith('+') || raw.startsWith('00')
  let digits = raw.replace(/\D/g, '')

  if (raw.startsWith('00')) {
    digits = digits.slice(2)
  } else if (!hasInternationalPrefix) {
    if (!callingCode) return undefined

    if (!digits.startsWith(callingCode)) {
      if (!countriesWithSignificantLeadingZero.includes(normalisedCountryCode)) {
        digits = digits.replace(/^0/, '')
      }
      digits = callingCode + digits
    }
  }

  if (callingCode && !digits.startsWith(callingCode)) return undefined

  if (
    callingCode &&
    !countriesWithSignificantLeadingZero.includes(normalisedCountryCode) &&
    digits.slice(callingCode.length).startsWith('0')
  ) {
    digits = callingCode + digits.slice(callingCode.length + 1)
  }

  const telephone = '+' + digits

  return /^\+[1-9]\d{6,14}$/.test(telephone) ? telephone : undefined
}
